import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-custom-action',
    standalone: false,
    templateUrl: './custom-action.component.html',
    styleUrl: './custom-action.component.scss'
})
export class CustomActionComponent {
    @Input() columnDetails: any;
    @Input() rowData: any;
    @Input() entity: any;
    @Input() selectedRow: any = [];
    @Output() actioncComponentEvent: EventEmitter<any> = new EventEmitter<any>();
}
